import { AiChatMessageMode } from '@server/ai';
import type { AgentsHomeState } from './agentsHomeReducer';
import { agentsHomeInitialState } from './agentsHomeReducer';

const VALID_MODES = new Set<string>(Object.values(AiChatMessageMode));

/**
 * Sanitizes a persisted advancedMode value that may be stale after enum renames
 * (e.g. the old AgentInputMode.None = 'none' string).
 */
const normalizeAdvancedMode = (value: unknown): AiChatMessageMode | undefined =>
  typeof value === 'string' && VALID_MODES.has(value) ? (value as AiChatMessageMode) : undefined;

/**
 * Returns the subset of AgentsHomeState to persist to localStorage,
 * with any stale values sanitized.
 */
export const agentsHomePersistedStateHandler = (state: AgentsHomeState) => ({
  ...agentsHomeInitialState,
  advancedMode: normalizeAdvancedMode(state.advancedMode),
});
